import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';

/** @class ExpoMetadata
  * A component for editing the metadata of an Expo
  */
export default class ExpoMetadata extends Component {
  /** @constructor
    * Constructs a new instance of ExpoMetadata
    */
  constructor(props) {
    super(props)
    this.state = {
      name: props.name,
      host: props.host,
      status: props.status
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @method componentWillReceiveProps
    * Updates the component state with updated props.
    * @param {object} newProps - the component's new props
    */
  componentWillReceiveProps(newProps) {
    this.setState({
      name: newProps.name,
      host: newProps.host,
      status: newProps.status
    });
  }
  /** @method handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if(name === 'host') {
      // Changes to the host need to be applied to the firestore record
      firebase.firestore()
        .collection('hosts').doc(value)
        .set({expoID: this.props.expoID});
      firebase.firestore()
        .collection('hosts').doc(this.state.host)
        .delete();
    }
    this.setState({
      [name]: value
    });
  }
  /** @method handleBlur
    * Applies the current state to the database
    */
  handleBlur() {
    firebase.database().ref(this.props.dataURL).set(this.state);
  }
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <div>
        <div className="input-group">
          <label htmlFor="name">Name</label>
          <input name="name" type="text"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="host">Host</label>
          <input name="host" type="text"
            value={this.state.host}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/expo-editor/expo-metadata.js